import RequestService, {
    RequestServiceResponse,
} from '@tcc-online/request-service';
import IInfo from '../../types/common/IInfo';
import { GetThunkAPI } from '@reduxjs/toolkit/dist/createAsyncThunk';
import InfoSelectors from '../../selectors/InfoSelectors';
import LanguageSlice from '../../common/slices/LanguageSlice';
import { LanguageService } from './LanguageService';

const ENDPOINT = '/info';

const InfoService = {
    getInfo,
};

async function getInfo(
    _: undefined,
    thunk: GetThunkAPI<any>,
): Promise<RequestServiceResponse<IInfo> | undefined> {
    const { requestId } = InfoSelectors.getInfo(thunk.getState());
    const locale = LanguageSlice.state.getLocale(thunk.getState());

    if (requestId !== thunk.requestId) {
        return;
    }

    const response = await RequestService.get<IInfo>(
        `${ENDPOINT}`,
        {},
        { ignoreAuth: true },
    );

    if (response.data?.languages) {
        const languages = response.data.languages;
        if (!locale) {
            thunk.dispatch(
                LanguageSlice.actions.changeLocale(
                    LanguageService.getCurrentLocale(languages),
                ),
            );
        }

        thunk.dispatch(LanguageSlice.actions.changeAllowedLocales(languages));
    }

    return response;
}

export default InfoService;
